import { gql } from '@apollo/client';
import ORGANIZATION_FRAGMENT from './organization';
import ORGANIZATION_ROLE_FRAGMENT from './organization-role';
import ORGANIZATION_USER_FRAGMENT from './organization-user';

const USER_ORGANIZATION_FRAGMENT = gql`
  fragment BaseUserOrganization on UserOrganization {
    organizationId
    organization {
      ...BaseOrganization
      users {
        ...BaseOrganizationUser
      }
    }
    organizationRoles {
      ...BaseOrganizationRole
    }
  }
  ${ORGANIZATION_FRAGMENT}
  ${ORGANIZATION_USER_FRAGMENT}
  ${ORGANIZATION_ROLE_FRAGMENT}
`;

export default USER_ORGANIZATION_FRAGMENT;
